
document.addEventListener("DOMContentLoaded", function(event) {
  //Toggle content in oportunities page
  const fixedWidget = document.getElementById("ps-fixed-widget");
  const windowHeight = window.innerHeight;
  const docHeight = document.body.scrollHeight;
  const scrollRange = docHeight * 0.04; // First 10% of page
  const finalPosition = windowHeight * 0.88; // 95vh from top

  if(fixedWidget){
    const initialTop = fixedWidget.getBoundingClientRect().top
    const finalIncrement = finalPosition - initialTop;
    console.log(finalIncrement)
    console.log(initialTop)

    window.addEventListener('scroll', function() {
      const scrollPosition = window.scrollY;
      
      // Only animate during first 10% of scroll
      if (scrollPosition <= scrollRange) {
        const progress = Math.min(scrollPosition / scrollRange, 1);
        
        // Calculate new position (from top:0 to bottom:0)
        const newPosition = finalIncrement * progress;
        
        // Apply the movement
        fixedWidget.style.transform = `translateY(${newPosition}px)`;
        
        // Alternative approach using top property:
        // element.style.top = `${newPosition}px`;
      }else {
        // Ensure it stays at final position if scrolled beyond 10%
        fixedWidget.style.transform = `translateY(${finalIncrement}px)`;
      }
    });
  }
    
});




